export default __webpack_public_path__ + "static/media/rolling.0526c158.svg";